<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card shaped>
        <v-card-title>
          <v-icon large left color="primary">mdi-account-group-outline</v-icon>
          <span class="title font-weight-light">Клиенты и комплекты</span>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading.download"
            :disabled="loading.report"
            @click="DownloadReport"
          >
            <v-icon left>mdi-microsoft-excel</v-icon>Скачать Excel
          </v-btn>
        </v-card-title>
        <v-col>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Немного об отчёте</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="text-justify mb-1">
                  Все выданные комплекты аптек и дистрибьюторов: строка — логин и комплект, строки сгруппированы по
                  компании (раскрываются). Тестовые комплекты не показываются. Менеджер — кто создал последнюю заявку
                  логина; регион — города компании (если не заданы, города логина).
                </p>
                <p class="text-justify mb-0">
                  Статус договора считается только для комплекта «Аптека и Оптимизированный заказ» по рабочим БИН
                  логина (если их нет — по БИН компании): «Отсутствует» — хотя бы по одному БИН договора нет.
                  Счётчики считаются по строкам с учётом фильтров; «платные/бесплатные» — только действующие.
                  Таблица показывается по страницам из компаний (по умолчанию 50 на страницу), счётчики и Excel — по всему
                  фильтру.
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-form ref="form" @submit.prevent="ApplyFilters">
          <v-row class="px-4">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="search.search" label="Логин или компания" prepend-icon="mdi-magnify" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field v-model="search.bin" label="БИН" clearable></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select v-model="search.clientType" :items="options.clientTypes" item-text="name" item-value="id" label="Тип клиента" clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="search.accessTemplateIds"
                :items="templateItems"
                item-text="name"
                item-value="id"
                label="Комплект"
                multiple
                chips
                small-chips
                deletable-chips
                :loading="loading.options"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select v-model="search.accessKind" :items="accessKindOptions" label="Тип доступа" clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select v-model="search.accessStatus" :items="accessStatusOptions" label="Статус доступа" clearable></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select v-model="search.agreementStatus" :items="options.agreementStatuses" label="Статус договора" clearable persistent-hint hint="Только главный комплект"></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="search.cityIds"
                :items="options.cities"
                item-text="name"
                item-value="id"
                label="Регион (город)"
                multiple
                chips
                small-chips
                deletable-chips
                :loading="loading.options"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-select v-model="search.managerUserId" :items="options.managers" item-text="login" item-value="id" label="Менеджер" clearable :loading="loading.options"></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex">
              <v-text-field v-model="search.accessEndFrom" type="date" label="Окончание доступа с" class="mr-2"></v-text-field>
              <v-text-field v-model="search.accessEndTo" type="date" label="по"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="d-flex">
              <v-text-field v-model="search.agreementEndFrom" type="date" label="Окончание договора с" class="mr-2"></v-text-field>
              <v-text-field v-model="search.agreementEndTo" type="date" label="по"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="d-flex align-center">
              <v-btn color="primary" type="submit" :loading="loading.report" block>Показать</v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="d-flex align-center">
              <v-btn text block @click="ResetFilters">Сбросить</v-btn>
            </v-col>
          </v-row>
        </v-form>

        <v-row class="px-4 pb-2">
          <v-col cols="auto"><v-chip color="green" dark>Платные: {{ report.counters.paid }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="teal" dark>Бесплатные: {{ report.counters.free }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="orange" dark>Заканчиваются ≤ 30 дн.: {{ report.counters.expiring30 }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="deep-orange" dark>≤ 14 дн.: {{ report.counters.expiring14 }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="red" dark>≤ 7 дн.: {{ report.counters.expiring7 }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="grey" dark>Без договора: {{ report.counters.mainWithoutAgreement }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="red darken-3" dark>Договор истёк: {{ report.counters.agreementExpired }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="blue-grey" dark>Уникальных БИН: {{ report.counters.uniqueBins }}</v-chip></v-col>
          <v-col cols="auto"><v-chip color="blue-grey" dark>Компаний: {{ report.counters.uniqueCompanies }}</v-chip></v-col>
        </v-row>

        <!-- Страница = N компаний (групп), не строк: группа компании не рвётся между страницами. Страницы отдаёт бэкенд -->
        <v-row class="px-4 pb-2" align="center">
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="paging.pageSize"
              :items="pageSizeOptions"
              label="Компаний на странице"
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="8" md="9" class="grey--text">
            Показаны компании {{ PageRange }} из {{ report.totalGroups }}, всего строк {{ report.totalRows }}
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="rows"
          :loading="loading.report"
          :items-per-page="-1"
          hide-default-footer
          disable-pagination
          group-by="companyKey"
          class="elevation-1"
        >
          <!-- Заголовок группы: компания, раскрывается на все комплекты всех её логинов (решение заказчика R2) -->
          <template v-slot:group.header="{ group, items, isOpen, toggle }">
            <th :colspan="headers.length" class="group-header">
              <v-btn icon small @click="toggle" class="mr-1">
                <v-icon>{{ isOpen ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
              </v-btn>
              <strong>{{ items[0].companyName || "Без компании" }}</strong>
              <span v-if="items[0].bins" class="grey--text ml-2">БИН {{ items[0].bins }}</span>
              <v-chip x-small class="ml-2" outlined>{{ items[0].clientType }}</v-chip>
              <span class="grey--text ml-2">{{ items.length }} {{ Plural(items.length, "комплект", "комплекта", "комплектов") }}, {{ LoginsCount(items) }} {{ Plural(LoginsCount(items), "логин", "логина", "логинов") }}</span>
              <span class="d-none">{{ group }}</span>
            </th>
          </template>
          <template v-slot:item.accessTemplateName="{ item }">
            {{ item.accessTemplateName }}<span v-if="item.templateHidden" class="grey--text"> (скрыт)</span>
          </template>
          <template v-slot:item.accessKindTitle="{ item }">
            <v-chip x-small :color="item.accessKind === 1 ? 'teal' : 'green'" dark>{{ item.accessKindTitle }}</v-chip>
          </template>
          <template v-slot:item.dateStart="{ item }">{{ FormatDate(item.dateStart) }}</template>
          <template v-slot:item.dateEnd="{ item }">{{ FormatDate(item.dateEnd) }}</template>
          <template v-slot:item.accessStatus="{ item }">
            <v-chip small dark :color="StatusColor(item.accessStatus)">{{ item.accessStatus }}</v-chip>
          </template>
          <template v-slot:item.agreementStatus="{ item }">
            <v-chip v-if="item.agreementStatus" small dark :color="AgreementColor(item.agreementStatus)">{{ item.agreementStatus }}</v-chip>
          </template>
          <template v-slot:item.agreementExpirationDate="{ item }">{{ FormatDate(item.agreementExpirationDate) }}</template>
        </v-data-table>

        <v-pagination
          v-if="report.totalPages > 1"
          v-model="paging.pageNumber"
          :length="report.totalPages"
          :total-visible="9"
          :disabled="loading.report"
          class="py-3"
        ></v-pagination>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { ACCESS_KIND_PAID, ACCESS_KIND_FREE } from "@/utils/accessKind";

const emptySearch = () => ({
  search: "",
  bin: "",
  clientType: null,
  accessTemplateIds: [],
  accessKind: null,
  accessStatus: null,
  agreementStatus: null,
  cityIds: [],
  managerUserId: null,
  accessEndFrom: "",
  accessEndTo: "",
  agreementEndFrom: "",
  agreementEndTo: "",
});

export default {
  data: () => ({
    search: emptySearch(),
    options: { templates: [], cities: [], managers: [], clientTypes: [], agreementStatuses: [] },
    report: { rows: [], counters: {}, totalGroups: 0, totalRows: 0, totalPages: 0 },
    // страница = pageSize компаний; значения по умолчанию те же, что ClientsComplectsPagedSearch на бэке
    paging: { pageNumber: 1, pageSize: 50 },
    pageSizeOptions: [25, 50, 100, 200],
    loading: { options: true, report: false, download: false },
    accessKindOptions: [
      { text: "Платный", value: ACCESS_KIND_PAID },
      { text: "Бесплатный", value: ACCESS_KIND_FREE },
    ],
    // значения — AccessStatusFilter на бэке
    accessStatusOptions: [
      { text: "Активен", value: 1 },
      { text: "Заканчивается (≤ 30 дн.)", value: 2 },
      { text: "Истёк", value: 3 },
      { text: "Не начался", value: 4 },
    ],
    headers: [
      { text: "Логин", value: "login" },
      { text: "Точка", value: "pharmacyName" },
      { text: "Комплект", value: "accessTemplateName" },
      { text: "Тип доступа", value: "accessKindTitle" },
      { text: "Начало", value: "dateStart" },
      { text: "Окончание", value: "dateEnd" },
      { text: "Дней", value: "daysLeft", align: "end" },
      { text: "Статус доступа", value: "accessStatus" },
      { text: "Менеджер", value: "managerLogin" },
      { text: "Регион", value: "cities" },
      { text: "Комментарий", value: "comment" },
      { text: "Договор", value: "agreementStatus" },
      { text: "Срок договора", value: "agreementExpirationDate" },
    ],
  }),
  computed: {
    templateItems() {
      return (this.options.templates || []).map((t) => ({ id: t.id, name: t.hidden ? `${t.name} (скрыт)` : t.name }));
    },
    // ключ группы: название компании + id (Vuetify сортирует группы по ключу, поэтому название идёт первым);
    // логин без компании — своя группа, чтобы «Без компании» не склеивало чужих логинов
    rows() {
      return (this.report.rows || []).map((r) => ({
        ...r,
        companyKey: r.companyId != null
          ? `${(r.companyName || "").toLowerCase()}|c${r.companyId}`
          : `яяя|u${r.userId}`,
      }));
    },
    PageRange() {
      if (!this.report.totalGroups) return "0";
      const from = (this.report.pageNumber - 1) * this.report.pageSize + 1;
      const to = Math.min(from + this.report.pageSize - 1, this.report.totalGroups);
      return `${from}–${to}`;
    },
  },
  watch: {
    "paging.pageNumber"(value) {
      // после подрезки номера бэкендом страница уже загружена — второй запрос не нужен
      if (value !== this.report.pageNumber) this.LoadReport();
    },
    "paging.pageSize"() {
      this.ApplyFilters();
    },
  },
  async mounted() {
    await this.GetFilterOptions();
    this.LoadReport();
  },
  methods: {
    async GetFilterOptions() {
      this.loading.options = true;
      try {
        this.options = await this.$store.dispatch("CLIENTS_COMPLECTS_FILTER_OPTIONS");
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.options = false;
      }
    },
    Request() {
      const s = this.search;
      return {
        search: s.search || null,
        bin: s.bin || null,
        clientType: s.clientType,
        accessTemplateIds: s.accessTemplateIds,
        accessKind: s.accessKind,
        accessStatus: s.accessStatus,
        agreementStatus: s.agreementStatus || null,
        cityIds: s.cityIds,
        managerUserId: s.managerUserId,
        accessEndFrom: s.accessEndFrom || null,
        accessEndTo: s.accessEndTo || null,
        agreementEndFrom: s.agreementEndFrom || null,
        agreementEndTo: s.agreementEndTo || null,
      };
    },
    // «Показать», «Сбросить», смена размера страницы — всегда с первой страницы
    ApplyFilters() {
      if (this.paging.pageNumber !== 1) {
        this.paging.pageNumber = 1; // watcher сам вызовет LoadReport
        return;
      }
      this.LoadReport();
    },
    async LoadReport() {
      this.loading.report = true;
      try {
        const started = performance.now();
        const data = await this.$store.dispatch("CLIENTS_COMPLECTS_REPORT_PAGED", {
          search: this.Request(),
          pageNumber: this.paging.pageNumber,
          pageSize: this.paging.pageSize,
        });
        this.report = data;
        // бэкенд мог подрезать номер страницы (страница за концом после смены фильтра)
        if (data.pageNumber !== this.paging.pageNumber) this.paging.pageNumber = data.pageNumber;
        window.console.log(`ClientsComplects: страница ${data.pageNumber}/${data.totalPages}, ${data.rows.length} строк за ${Math.round(performance.now() - started)} мс`);
      } catch (error) {
        window.console.log(error);
      } finally {
        this.loading.report = false;
      }
    },
    DownloadReport() {
      this.loading.download = true;
      this.$store
        .dispatch("DOWNLOAD_CLIENTS_COMPLECTS_REPORT", this.Request())
        .catch((error) => window.console.log(error))
        .finally(() => {
          this.loading.download = false;
        });
    },
    ResetFilters() {
      this.search = emptySearch();
      this.ApplyFilters();
    },
    LoginsCount(items) {
      return new Set(items.map((i) => i.userId)).size;
    },
    Plural(n, one, few, many) {
      const m10 = n % 10, m100 = n % 100;
      if (m10 === 1 && m100 !== 11) return one;
      if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
      return many;
    },
    FormatDate(value) {
      return value ? this.$options.filters.toDate(String(value).substr(0, 10)) : "";
    },
    StatusColor(status) {
      switch (status) {
        case "Активен":
          return "green";
        case "Заканчивается":
          return "orange";
        case "Истёк":
          return "red";
        default:
          return "grey";
      }
    },
    AgreementColor(status) {
      switch (status) {
        case "Действует":
          return "green";
        case "Заканчивается":
          return "orange";
        case "Истёк":
          return "red";
        default:
          return "grey";
      }
    },
  },
};
</script>

<style scoped>
.group-header {
  background: #f5f5f5;
}
</style>
